import { useState, useEffect, useCallback } from "react";
import { fetchAnalyticsDashboard } from "../api/analyticsapi";

/**
 * @param {string}      range       - "7d" | "30d" | "90d"
 * @param {string|null} patientId   - specific patient's owner_id, or null for all users
 */
export function useAnalytics(range, patientId = null) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const load = useCallback(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(null);
    setData(null);

    fetchAnalyticsDashboard(range, patientId, controller.signal)
      .then((result) => { setData(result); setLoading(false); })
      .catch((err) => {
        if (err.name === "AbortError") return;
        setError(err.message || "Failed to load analytics");
        setLoading(false);
      });

    return () => controller.abort();
  }, [range, patientId]);

  useEffect(() => {
    const cleanup = load();
    return cleanup;
  }, [load]);

  return { data, loading, error, refetch: load };
}